var React = require('react');

function SkillRectangle (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#131415","strokeWidth":"3","fillRule":"evenodd"},[React.createElement("path",{"strokeLinejoin":"bevel","d":"M328.58 25v80.1H1.75V25z","key":0}),React.createElement("path",{"strokeLinejoin":"bevel","d":"M358 1.53L327.41 25l-326.38.73 38.55-24.2z","key":1}),React.createElement("path",{"strokeLinejoin":"round","d":"M357.78 1.53l.01 83.77-29 19.46V24.37z","key":2})]));
}

SkillRectangle.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 360 107"};

module.exports = SkillRectangle;

SkillRectangle.default = SkillRectangle;
